import {RouteConfig} from "vue-router";
const Login = () => import('../views/auth/Login.vue');

let auth: RouteConfig[] = [
    {
        name: 'login',
        path: '/login',
        component: Login,
        meta: {
            allowLoggedOut: true,
            onlyLoggedOut: true,
        },
    },
    {
        path: '/login/referrer/:referrer?',
        name: 'login-referrer',
        component: Login,
        meta: {
            allowLoggedOut: true,
            onlyLoggedOut: true,
        },
    },
    {
        path: '/logout',
        name: 'logout',
    },
];

export default auth;
